
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function AdminRoute({ children }) {
  const { user, token } = useSelector((state) => state.auth);

  // Login nahi hai
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Admin nahi hai
  if (user?.role !== 'Admin') {
    return <Navigate to="/dashboard" replace />;
  }

  // Admin hai
  return children;
}

export default AdminRoute;

